var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9375 8.9384C24.9375 9.2504 24.8098 9.5624 24.5534 9.80046L14.9292 18.7371C14.4174 19.2133 13.5861 19.2133 13.0734 18.7371L3.44838 9.80046C2.93563 9.32433 2.93563 8.55327 3.44838 8.07714C3.96025 7.60102 4.7915 7.60102 5.30425 8.07714L14.0009 16.1518L22.6966 8.07715C23.2094 7.60102 24.0398 7.60102 24.5525 8.07715C24.8098 8.3144 24.9375 8.6264 24.9375 8.9384Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.13459cd48b0609a1c33a030eed68c158.svg";
export { ForwardRef as ReactComponent };